import type { operations } from '@/types/schemas/api.main';
import { GET, setParams } from '../../_http';
type controller = operations['CustomerRetrieveScenarioController_get'];

export type CustomerRetrieveScenarioQuery = controller['parameters']['query'];
export type CustomerRetrieveScenarioResponse = controller['responses']['200']['content']['application/json'];

export const retrieveCustomerScenario = GET(
  '/users/scenarios/scenario',
  setParams<CustomerRetrieveScenarioQuery>,
)<CustomerRetrieveScenarioResponse>;
